module.exports = __webpack_public_path__ + "static/resume-3e48f0b22b05079c2eefa25b62c60fe5.pdf";